import previewPage from 'AssetEditor/pages/Preview.vue';
import AudioPage from 'AssetEditor/pages/Audio.vue';
import ZoomPage from 'AssetEditor/pages/Zoom.vue';
import OverlayAssetPage from 'AssetEditor/pages/OverlayAsset.vue';
import TextOverlayPage from 'AssetEditor/pages/TextOverlay.vue';
import SuperPage from 'AssetEditor/pages/Super.vue';
import CreditPage from 'AssetEditor/pages/Credit.vue';
import SubtitlesPage from 'AssetEditor/pages/Subtitles.vue';
import CustomPage from 'AssetEditor/pages/Custom.vue';

export default {
  previewPage,
  AudioPage,
  CropPage: previewPage,
  ZoomPage,
  TextOverlayPage,
  SuperPage,
  CreditPage,
  SubtitlesPage,
  CustomPage,
  OverlayAssetPage,
};
